(function () {
  'use strict';

  function initGalleryArrows() {
    var section = document.querySelector('.arn-pdp-v2');
    if (!section) return;

    var slider = section.querySelector('.js-slider-for');
    if (!slider) return;

    var prevBtn = section.querySelector('[data-arn-gallery-prev]');
    var nextBtn = section.querySelector('[data-arn-gallery-next]');

    function callSlick(method) {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        try { window.jQuery(slider).slick(method); } catch (e) { /* noop */ }
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { callSlick('slickPrev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { callSlick('slickNext'); });
  }

  function initLightbox() {
    var section = document.querySelector('.arn-pdp-v2');
    var lightbox = document.getElementById('arn-pdp-lightbox');
    if (!section || !lightbox) return;

    var slider = section.querySelector('.arn-pdp-v2__slider-for');
    if (!slider) return;

    var imgEl = lightbox.querySelector('[data-arn-lb-img]');
    var counterCurrent = lightbox.querySelector('[data-arn-lb-current]');
    var counterTotal = lightbox.querySelector('[data-arn-lb-total]');
    var btnClose = lightbox.querySelector('[data-arn-lb-close]');
    var btnPrev = lightbox.querySelector('[data-arn-lb-prev]');
    var btnNext = lightbox.querySelector('[data-arn-lb-next]');
    var stage = lightbox.querySelector('[data-arn-lb-stage]');

    var images = [];
    var currentIdx = 0;

    function getImages() {
      var slides = slider.querySelectorAll('.slick-slide:not(.slick-cloned) .item img');
      if (slides.length === 0) slides = slider.querySelectorAll('.item img');
      return Array.prototype.map.call(slides, function (img) { return img.src; });
    }

    function show(idx) {
      if (!images.length) return;
      if (idx < 0) idx = images.length - 1;
      if (idx >= images.length) idx = 0;
      currentIdx = idx;
      if (imgEl) imgEl.src = images[idx];
      if (counterCurrent) counterCurrent.textContent = idx + 1;
      if (counterTotal) counterTotal.textContent = images.length;
      var multi = images.length > 1;
      if (btnPrev) btnPrev.style.visibility = multi ? '' : 'hidden';
      if (btnNext) btnNext.style.visibility = multi ? '' : 'hidden';
    }

    function open(idx) {
      images = getImages();
      if (!images.length) return;
      show(idx);
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    var startX = 0, startY = 0, moved = false, downImg = null;
    slider.addEventListener('pointerdown', function (e) {
      var img = e.target.closest('.item img');
      if (!img) return;
      startX = e.clientX; startY = e.clientY; moved = false; downImg = img;
    });
    slider.addEventListener('pointermove', function (e) {
      if (!downImg) return;
      if (Math.abs(e.clientX - startX) > 6 || Math.abs(e.clientY - startY) > 6) moved = true;
    });
    slider.addEventListener('pointerup', function (e) {
      var img = e.target.closest('.item img');
      if (!img || !downImg || moved) { downImg = null; return; }
      var slides = slider.querySelectorAll('.slick-slide:not(.slick-cloned) .item img');
      var idx = -1;
      if (slides.length) idx = Array.prototype.indexOf.call(slides, img);
      if (idx < 0) {
        var srcImages = getImages();
        idx = srcImages.indexOf(img.src);
      }
      if (idx < 0) idx = 0;
      e.preventDefault();
      open(idx);
      downImg = null;
    });

    if (btnClose) btnClose.addEventListener('click', close);
    if (btnPrev) btnPrev.addEventListener('click', function () { show(currentIdx - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { show(currentIdx + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === stage) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(currentIdx - 1);
      else if (e.key === 'ArrowRight') show(currentIdx + 1);
    });

    var touchStartX = 0;
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (e.changedTouches.length !== 1) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) show(currentIdx + 1);
          else show(currentIdx - 1);
        }
      });
    }
  }

  function initLoopSubscribeHighlight() {
    var wrap = document.querySelector('.arn-pdp-v2__loop-wrap');
    if (!wrap) return;

    function applyHighlight() {
      wrap.querySelectorAll('.arn-loop-subscribe-option').forEach(function (el) {
        el.classList.remove('arn-loop-subscribe-option');
      });

      var radios = wrap.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;

      radios.forEach(function (radio) {
        var node = radio.parentElement;
        var found = null;
        var hops = 0;

        while (node && node !== wrap && node !== document.body && hops < 8) {
          var text = (node.textContent || '').toLowerCase();
          var hasSubscribe = /\bsubscribe\b/.test(text);
          var hasSavePct = /save\s*\d+\s*%/.test(text) || /\d+\s*%\s*off/.test(text);
          var hasOneTime = /one[\s-]?time/.test(text) || /one[\s-]?off/.test(text);

          if (hasOneTime) break;
          if (hasSubscribe || hasSavePct) found = node;

          node = node.parentElement;
          hops++;
        }

        if (found && found !== wrap) {
          found.classList.add('arn-loop-subscribe-option');
        }
      });
    }

    applyHighlight();

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () { applyHighlight(); });
      observer.observe(wrap, { childList: true, subtree: true });
    }
  }

  // ============================================================
  // Free shipping progress bar
  // Fetches /cart.js, fills the bar based on cart_total / threshold,
  // updates copy and unlocked state. Refetches on cart events and
  // after the ATC button is clicked.
  // ============================================================
  function initFreeShippingBar() {
    var bar = document.querySelector('[data-arn-shipping-bar]');
    if (!bar) return;

    var fill = bar.querySelector('[data-arn-shipping-fill]');
    var text = bar.querySelector('[data-arn-shipping-text]');
    var threshold = parseFloat(bar.dataset.shippingThreshold) || 60;
    var thresholdCents = Math.round(threshold * 100);

    var symbols = { EUR: '€', GBP: '£', USD: '$', CAD: 'C$', AUD: 'A$' };

    function formatAmount(cents, symbol) {
      var amount = cents / 100;
      var formatted = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
      return symbol + formatted;
    }

    function update(cart) {
      if (!cart) return;
      var total = typeof cart.total_price === 'number' ? cart.total_price : 0;
      var symbol = symbols[cart.currency] || '€';
      var pct = thresholdCents > 0 ? Math.min(100, (total / thresholdCents) * 100) : 0;
      var remaining = Math.max(0, thresholdCents - total);

      if (fill) fill.style.width = pct + '%';

      if (text) {
        if (total === 0) {
          text.textContent = 'Free shipping ' + symbol + threshold + '+';
        } else if (remaining > 0) {
          text.textContent = formatAmount(remaining, symbol) + ' away from free shipping';
        } else {
          text.textContent = 'Free shipping unlocked';
        }
      }

      if (total >= thresholdCents && total > 0) {
        bar.classList.add('is-unlocked');
      } else {
        bar.classList.remove('is-unlocked');
      }
    }

    function fetchAndUpdate() {
      if (typeof fetch === 'undefined') return;
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(update)
        .catch(function () { /* noop */ });
    }

    fetchAndUpdate();

    // Common theme cart events
    var cartEvents = ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:items-added', 'cart:change'];
    cartEvents.forEach(function (evt) {
      document.addEventListener(evt, fetchAndUpdate);
      window.addEventListener(evt, fetchAndUpdate);
    });

    // Refetch after ATC click — covers themes that don't fire a cart event
    var atcBtns = document.querySelectorAll('.arn-pdp-v2__atc a, .js-pdp-atc, .js-pdp-atc a');
    atcBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(fetchAndUpdate, 1500);
        setTimeout(fetchAndUpdate, 3500);
      });
    });

    // Catch background tab → foreground transitions (cart may have changed elsewhere)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fetchAndUpdate();
    });
  }

  function init() {
    initGalleryArrows();
    initLightbox();
    initLoopSubscribeHighlight();
    initFreeShippingBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();